/**
 * Copy Button Module
 */

export function initCopyButtons() {
	const btns = document.querySelectorAll('[data-copy]');

	btns.forEach((btn) => {
		btn.addEventListener('click', () => {
			const text = btn.dataset.copy;
			if (!text) return;

			navigator.clipboard.writeText(text).then(() => {
				wpcore.alert('success', wpcore.direct_t({ en: 'Copied to clipboard', fr: 'Copié dans le presse-papiers' }));
				const icon = btn.querySelector('.fi-rr-copy, .fi-rr-share');
				if (!icon) return;

				const original = icon.className;
				icon.className = 'fi fi-rr-check';
				btn.disabled = true;

				setTimeout(() => {
					icon.className = original;
					btn.disabled = false;
				}, 1500);
			});
		});
	});
}
